export function EonLogo({ size = 40, borderRadius = 8 }) {
  return (
    <img
      src="/eon_logga.png"
      alt="Eon"
      width={size}
      height={size}
      style={{ borderRadius, flexShrink: 0, objectFit: 'cover' }}
    />
  )
}
